"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuBehavior = exports.OPEN_STATE = exports.ACTIVE_STATE = exports.COLLAPSED_STATE = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var menu_constants_1 = require("./menu-constants");
var menu_constants_2 = require("./menu-constants");
var menu_constants_3 = require("./menu-constants");
var menu_constants_4 = require("./menu-constants");
var menu_constants_5 = require("./menu-constants");
var menu_constants_6 = require("./menu-constants");
var menu_constants_7 = require("./menu-constants");
var menu_constants_8 = require("./menu-constants");
var menu_generator_1 = require("./menu-generator");
var menu_element_creator_1 = require("./menu-element-creator");
exports.COLLAPSED_STATE = 0;
exports.ACTIVE_STATE = 1;
exports.OPEN_STATE = 2;
var BcMenuBehavior = (function (_super) {
    __extends(BcMenuBehavior, _super);
    function BcMenuBehavior() {
        var _this = _super.call(this) || this;
        _this.items = new Map();
        _this.bodies = new Map();
        _this.state = exports.COLLAPSED_STATE;
        _this.stateSubMenu = exports.COLLAPSED_STATE;
        _this.stateOptionSubmenu = exports.COLLAPSED_STATE;
        _this.comunicationWithHeader = true;
        return _this;
    }
    BcMenuBehavior.setUpAll = function () {
        var menuElements = Array.from(document.querySelectorAll("div[class='".concat(menu_constants_4.BC_MENU, "']")));
        var elements = [];
        for (var _i = 0, menuElements_1 = menuElements; _i < menuElements_1.length; _i++) {
            var menuElement = menuElements_1[_i];
            var element = menuElement;
            var bc = new BcMenuBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcMenuBehavior.prototype.generateByConfig = function (config, parent) {
        var parentElement = parent;
        if (!(parent instanceof Element)) {
            parentElement = document.getElementById(parent.toString());
        }
        this.config = config;
        var generator = new menu_generator_1.BcMenuGenerator();
        this.mySelf = generator.generate(this.config);
        this.setUp();
        if (parentElement !== null) {
            parentElement.appendChild(this.mySelf);
        }
        return this.mySelf;
    };
    BcMenuBehavior.prototype._setUp = function () {
        try {
            this.getElements();
            this.addEvents();
            this.closeMegaMenu();
        }
        catch (e) {
            this.isReady = false;
        }
    };
    BcMenuBehavior.prototype.setState = function (state) {
        this.state = state;
        if (this.state === exports.COLLAPSED_STATE) {
            (0, helpers_1.replaceClass)(this.drawer, menu_constants_1.BC_MENU_DRAWER_ACTIVE, menu_constants_2.BC_MENU_DRAWER);
            (0, helpers_1.replaceClass)(this.mainContent, menu_constants_2.BC_MENU_MAIN_CONTENT_ACTIVE, menu_constants_8.BC_MENU_MAIN_CONTENT);
            this.showHideBtnFab();
        }
        else if (this.state === exports.ACTIVE_STATE) {
            (0, helpers_1.replaceClass)(this.drawer, menu_constants_2.BC_MENU_DRAWER, menu_constants_1.BC_MENU_DRAWER_ACTIVE);
            (0, helpers_1.replaceClass)(this.mainContent, menu_constants_2.BC_MENU_MAIN_CONTENT_ACTIVE, menu_constants_8.BC_MENU_MAIN_CONTENT);
            this.showHideBtnFab();
        }
        else if (this.state === exports.OPEN_STATE) {
            (0, helpers_1.replaceClass)(this.mainContent, menu_constants_8.BC_MENU_MAIN_CONTENT, menu_constants_2.BC_MENU_MAIN_CONTENT_ACTIVE);
            var active = this.mySelf.querySelector(".".concat(menu_constants_2.BC_MENU_MAIN_CONTENT_ACTIVE));
            active.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_MD);
        }
    };
    BcMenuBehavior.prototype.getState = function () {
        return this.state;
    };
    BcMenuBehavior.prototype.addItemsEvents = function () {
        var _this = this;
        var i = 0;
        this.items.forEach(function (item, key) {
            var _itemClickEvent = _this.openItemClick(item, key, i);
            i++;
            var _overItemEvent = function () {
                _this.setItemsEvents(item);
            };
            _overItemEvent();
            window.onresize = function () {
                _overItemEvent();
            };
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                if (item.getAttribute(common_constants_1.BcCommonConstants.ATTR_HREF) === '#' ||
                    item.getAttribute(common_constants_1.BcCommonConstants.ATTR_HREF) === '') {
                    event.preventDefault();
                }
                _itemClickEvent(event);
            });
        });
    };
    BcMenuBehavior.prototype.setItemsEvents = function (item) {
        var _this = this;
        if (window.innerWidth >= menu_constants_7.BC_LG) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOVER, function (event) {
                if (item !== _this.selectedItem) {
                    _this.showHideBtnFab();
                }
            });
        }
        else {
            item.removeEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOVER, function () { });
            item.removeEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOUT, function () { });
        }
    };
    BcMenuBehavior.prototype.setInitState = function () {
        var _this = this;
        this.stateInitial = this.mySelf.getAttribute('state');
        if (this.stateInitial === 'open') {
            this.setState(exports.ACTIVE_STATE);
            this.addCloseButtonEvent(exports.ACTIVE_STATE);
        }
        else {
            this.setState(exports.COLLAPSED_STATE);
            this.drawer.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOUT, function () {
                if (_this.state === exports.ACTIVE_STATE) {
                    _this.setState(exports.COLLAPSED_STATE);
                    _this.showHideBtnFab();
                    _this.changeMenuOverflow(common_constants_1.BcCommonConstants.HIDDEN);
                }
            });
            this.addCloseButtonEvent(exports.COLLAPSED_STATE);
        }
    };
    BcMenuBehavior.prototype.addCloseButtonEvent = function (state) {
        var _this = this;
        this.closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.setState(state);
            _this.showHideBtnFab();
            _this.toggleItem();
        });
    };
    BcMenuBehavior.prototype.addDrawerEvents = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.setInitState();
            }
        });
        this.drawer.addEventListener(common_constants_1.BcCommonConstants.EVENT_MOUSEOVER, function () {
            if (_this.state === exports.COLLAPSED_STATE) {
                _this.setState(exports.ACTIVE_STATE);
                _this.showHideBtnFab();
            }
        });
    };
    BcMenuBehavior.prototype.addEvents = function () {
        this.addItemsEvents();
        this.addDrawerEvents();
        if (this.comunicationWithHeader) {
            if (this.mySelf.classList.contains('bc-menu-global-container')) {
                this.mySelf.classList.add('bc-menu-with-header');
            }
            else {
                this.mySelf.parentElement.classList.add('bc-menu-with-header');
            }
            this.toggleEvent();
            this.quantityItemsEvent();
            this.headerIsReady();
        }
    };
    BcMenuBehavior.prototype.getElements = function () {
        this.mainContent = this.mySelf.querySelector("div[class^='".concat(menu_constants_8.BC_MENU_MAIN_CONTENT, "']"));
        if (this.mainContent !== null) {
            this.getBodies();
        }
        this.drawer = this.mySelf.querySelector("ul[class^='".concat(menu_constants_2.BC_MENU_DRAWER, "']"));
        if (this.drawer !== null) {
            this.getItems();
        }
        else {
            throw Error(menu_constants_7.BC_DRAWER_ERROR);
        }
        this.closeButton = this.mySelf.querySelector(".bc-menu-content-header *[class^='".concat(menu_constants_2.BC_CLOSE_BUTTON, "']"));
        this.setInitState();
    };
    BcMenuBehavior.prototype.validateCloseSesionButton = function () {
        var footer = this.mySelf.querySelector("*[class='".concat(menu_constants_1.BC_MENU_SUBMENU_FOOTER_CONTAINER, "']"));
        if (footer) {
            if (this.items.size > menu_constants_5.MAX_ITEMS) {
                footer.remove();
            }
        }
    };
    BcMenuBehavior.prototype.getBodies = function () {
        this.groupCollectionByProperty(this.mainContent, menu_constants_3.BC_MENU_CONTENT_BODY, 'id', this.bodies);
    };
    BcMenuBehavior.prototype.getItems = function () {
        var _this = this;
        this.groupCollectionByProperty(this.drawer, menu_constants_3.BC_MENU_ITEM, 'for', this.items);
        this.items.forEach(function (element, key, array) {
            if (_this.bodies.get(key)) {
                var imgElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
                imgElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.X_SMALL_CLASS);
                imgElement.innerText = 'arrow2-right';
                element.querySelector(common_constants_1.BcCommonConstants.LI_TAG).appendChild(imgElement);
            }
            _this.getCurrentItemActive(element);
        });
        this.structureExtraItems();
        setTimeout(function () {
            _this.validateCloseSesionButton();
        });
    };
    BcMenuBehavior.prototype.structureConfigByResize = function (width) {
        var _this = this;
        var itemsInside = this.submenu.querySelectorAll("a[class^='".concat(menu_constants_3.BC_MENU_ITEM, "']"));
        if (width < menu_constants_7.BC_LG) {
            itemsInside.forEach(function (item) {
                var identifier = item.getAttribute('for');
                var body = _this.bodies.get(identifier);
                _this.addItemEventClick(item, width, identifier);
                body && _this.addChevronIcon(item, body);
            });
        }
        else {
            if (this.itemElement && this.itemElement.parentElement) {
                this.itemElement.classList.remove(menu_constants_3.BC_MENU_ITEM_ACTIVE);
                this.itemElement.classList.remove(menu_constants_3.BC_MENU_ITEM);
            }
            itemsInside.forEach(function (item) {
                var i = item.querySelectorAll('em');
                if (i.length > 1) {
                    i[i.length - 1].innerText = 'arrow2-right';
                }
            });
            var mainContents = this.submenu.querySelectorAll("div[class^='".concat(menu_constants_3.BC_MENU_CONTENT_BODY, "']"));
            var bodiesContainer_1 = this.mainContent.querySelector("div[class^='".concat(menu_constants_6.BC_MENU_CONTENT_BODIES, "']"));
            mainContents.forEach(function (mainContent) {
                bodiesContainer_1.appendChild(mainContent);
            });
        }
    };
    BcMenuBehavior.prototype.structureExtraItems = function () {
        var _this = this;
        window.addEventListener('resize', function (event) {
            _this.structureConfigByResize(event.target.innerWidth);
        });
        this.createExtraElements();
        if (this.items.size > menu_constants_5.MAX_ITEMS) {
            this.logoutBtnContainer.classList.add('bigger');
        }
        this.itemElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.addEventCloseBtn();
        });
        this.closeBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.addEventCloseBtn();
        });
        if (this.items.size > 4) {
            this.drawer.appendChild(this.itemElement);
        }
        this.drawer.appendChild(this.submenu);
        var i = 0;
        var maxItems = 3;
        this.setItemsStructure(maxItems, i);
        this.items.set('', this.itemElement);
        this.submenuContentContainer.querySelectorAll('bc-menu-item').forEach(function (element) {
            element['style'].display = '';
        });
        this.submenu.appendChild(this.submenuContentContainer);
        this.submenu.appendChild(this.logoutBtnContainer);
        this.structureConfigByResize(window.innerWidth);
        this.setSubmenuBottomPos();
    };
    BcMenuBehavior.prototype.setItemsStructure = function (maxItems, i) {
        var _this = this;
        this.items.forEach(function (element, key, array) {
            if (i > maxItems) {
                if (!element.parentElement.classList.contains(menu_constants_2.BC_MENU_DRAWER)) {
                    element.parentElement['style'].display = common_constants_1.BcCommonConstants.NONE;
                }
                var validator = element.parentElement.parentElement.querySelector('bc-menu-item');
                if (validator) {
                    _this.submenuListContainer.appendChild(element.parentElement);
                }
                else {
                    _this.submenuListContainer.appendChild(element);
                }
            }
            else {
                _this.addEventClickOnExtra(element);
            }
            i++;
        });
    };
    BcMenuBehavior.prototype.groupCollectionByProperty = function (parent, clsName, attr, map) {
        var elements = (0, helpers_1.toArray)(parent.querySelectorAll("*[class^='".concat(clsName, "']")));
        elements.forEach(function (item) {
            var propertyValue = item.getAttribute(attr);
            if (propertyValue !== null) {
                map.set(propertyValue, item);
            }
        });
    };
    BcMenuBehavior.prototype.makeItemsInactive = function () {
        var _this = this;
        this.items.forEach(function (item, index) {
            _this.makeItemInactive(item);
        });
        this.changeMenuOverflow(common_constants_1.BcCommonConstants.HIDDEN);
    };
    BcMenuBehavior.prototype.makeItemActive = function (item, customClass) {
        if (customClass === void 0) { customClass = null; }
        var classToReplace = menu_constants_3.BC_MENU_ITEM_ACTIVE;
        if (customClass !== null) {
            classToReplace = customClass;
        }
        (0, helpers_1.replaceClass)(item, menu_constants_3.BC_MENU_ITEM, classToReplace);
        this.setMainContenPosition(item);
        this.toggleItem();
    };
    BcMenuBehavior.prototype.makeItemInactive = function (item) {
        (0, helpers_1.replaceClass)(item, menu_constants_3.BC_MENU_ITEM_ACTIVE, menu_constants_3.BC_MENU_ITEM, true);
        this.toggleItem();
        this.changeMenuOverflow(common_constants_1.BcCommonConstants.HIDDEN);
    };
    BcMenuBehavior.prototype.makeBodiesInactive = function () {
        var _this = this;
        this.bodies.forEach(function (item, index) {
            _this.makeBodyInactive(item);
        });
        this.changeMenuOverflow(common_constants_1.BcCommonConstants.HIDDEN);
    };
    BcMenuBehavior.prototype.makeBodyActive = function (item) {
        (0, helpers_1.replaceClass)(item, menu_constants_3.BC_MENU_CONTENT_BODY, menu_constants_4.BC_MENU_CONTENT_BODY_ACTIVE);
        this.changeMenuOverflow('visible');
    };
    BcMenuBehavior.prototype.makeBodyInactive = function (item) {
        (0, helpers_1.replaceClass)(item, menu_constants_4.BC_MENU_CONTENT_BODY_ACTIVE, menu_constants_3.BC_MENU_CONTENT_BODY);
        this.changeMenuOverflow(common_constants_1.BcCommonConstants.HIDDEN);
    };
    BcMenuBehavior.prototype.makeSubmenuInactive = function () {
        (0, helpers_1.replaceClass)(this.submenu, menu_constants_7.BC_MENU_SUBMENU_ACTIVE, menu_constants_5.BC_MENU_SUBMENU);
        var itemOptions = this.mySelf.querySelector(".".concat(menu_constants_5.BC_MENU_ITEM_OPTIONS));
        (0, helpers_1.replaceClass)(itemOptions, menu_constants_6.BC_MENU_ITEM_OPTIONS_ACTIVE, menu_constants_5.BC_MENU_ITEM_OPTIONS);
    };
    BcMenuBehavior.prototype.setMainContenPosition = function (item) {
        item = item ? item : this.mySelf.querySelector(".".concat(menu_constants_3.BC_MENU_ITEM_ACTIVE));
        var menu = (this.mySelf.classList.contains(menu_constants_4.BC_MENU)
            ? this.mySelf
            : this.mySelf.querySelector(".".concat(menu_constants_4.BC_MENU)));
        var contentActive = menu.querySelector(".".concat(menu_constants_1.BC_MENU_DRAWER_ACTIVE));
        var el = item;
        var main = this.mainContent;
        var maxColumns = 2;
        if (window.innerWidth > menu_constants_7.BC_SM && window.innerWidth < menu_constants_7.BC_LG) {
            var bodyActive = main.querySelector(".".concat(menu_constants_4.BC_MENU_CONTENT_BODY_ACTIVE));
            var columnsActive = bodyActive ? bodyActive.children.length : 0;
            menu.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            if (el.offsetLeft === 0) {
                main.style.left = '32px';
                if (columnsActive > maxColumns) {
                    main.classList.add(menu_constants_1.BC_MENU_COLUMNS);
                }
                else {
                    main.classList.remove(menu_constants_1.BC_MENU_COLUMNS);
                }
            }
            else {
                this.setMainContentPositionLeft(columnsActive, maxColumns, main, contentActive, el, menu);
            }
        }
        this.onResizeMainContain(menu, main);
    };
    BcMenuBehavior.prototype.setMainContentPositionLeft = function (columnsActive, maxColumns, main, contentActive, el, menu) {
        var mainWidth = 296;
        this.setMainContentWithLeftOfset(columnsActive, maxColumns, main, mainWidth, contentActive, el, menu);
    };
    BcMenuBehavior.prototype.setMainContentWithLeftOfset = function (columnsActive, maxColumns, main, mainWidth, contentActive, el, menu) {
        var contentChildren = 3;
        var factor = 2;
        if (columnsActive > 0 && columnsActive <= maxColumns) {
            var width = main.clientWidth > 0 ? main.clientWidth : mainWidth;
            if (contentActive.children[contentChildren] &&
                (contentActive.children[contentChildren].firstChild === el ||
                    contentActive.children[contentChildren] === el)) {
                var offsetRight = menu.offsetWidth - (el.offsetLeft + el.offsetWidth);
                main.style.right = "".concat(offsetRight - width / (maxColumns * factor), "px");
                main.style.left = 'auto';
            }
            else {
                main.style.right = 'auto';
                main.style.left = "".concat(el.offsetLeft - width / (maxColumns * factor), "px");
            }
        }
        else {
            main.style.left = '32px';
            main.style.width = 'calc(100vw - 60px)';
        }
    };
    BcMenuBehavior.prototype.showHideBtnFab = function () {
        if (window.innerWidth >= menu_constants_7.BC_LG) {
            var select = '.bc-submenu-footer-container';
            var footer = this.mySelf.querySelector(select)
                ? this.mySelf.querySelector(select).firstChild
                : null;
            if (footer != null) {
                if (this.drawer.className.indexOf('active') != -1) {
                    (0, helpers_1.replaceClass)(footer, common_constants_1.BcCommonConstants.BUTTON_FAB_CLASS, common_constants_1.BcCommonConstants.BC_BTN_CLASS);
                    (0, helpers_1.replaceClass)(footer, common_constants_1.BcCommonConstants.BUTTON_FAB_MINI_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS);
                    footer.classList.add(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS);
                    footer.classList.add('expanded');
                    footer.innerHTML = "<bc-icon class=\"bc-icon bc-sm\">quit</bc-icon> CERRAR SESI\u00D3N";
                }
                else {
                    (0, helpers_1.replaceClass)(footer, common_constants_1.BcCommonConstants.BC_BTN_CLASS, common_constants_1.BcCommonConstants.BUTTON_FAB_CLASS);
                    (0, helpers_1.replaceClass)(footer, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, common_constants_1.BcCommonConstants.BUTTON_FAB_MINI_CLASS);
                    footer.classList.remove(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS);
                    footer.classList.remove('expanded');
                    footer.innerHTML = "<bc-icon class=\"bc-icon bc-sm\">quit</bc-icon>";
                }
            }
        }
    };
    BcMenuBehavior.prototype.quantityItemsEvent = function () {
        if (this.items.get('')) {
            this.items.delete('');
        }
        if (this.items.size <= menu_constants_5.MAX_ITEMS) {
            var customEvent = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_MEMU_ITEMS);
            window.dispatchEvent(customEvent);
        }
    };
    BcMenuBehavior.prototype.setSubmenuBottomPos = function () {
        var _this = this;
        window.onload = function () {
            _this
                .submenu.style.height = "calc(100vh - ".concat(_this.drawer.clientHeight, "px)");
            _this
                .submenu.style.bottom = "".concat(_this.drawer.clientHeight, "px");
        };
    };
    BcMenuBehavior.prototype.toggleEvent = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_HEADER_TOGGLE_MENU, function () {
            var c = new Event(common_constants_1.BcCommonConstants.EVENT_CLICK);
            if (_this.state === exports.OPEN_STATE) {
                _this.closeButton.dispatchEvent(c);
            }
            else if (_this.state === exports.ACTIVE_STATE) {
                _this.setState(exports.COLLAPSED_STATE);
            }
            else {
                _this.setState(exports.ACTIVE_STATE);
            }
        });
    };
    BcMenuBehavior.prototype.toggleItem = function () {
        if (window.innerWidth <= menu_constants_7.BC_SM) {
            var selectorItem = menu_constants_3.BC_MENU_ITEM_ACTIVE;
            var selectorOpt = menu_constants_6.BC_MENU_ITEM_OPTIONS_ACTIVE;
            var itemActive = this.mySelf.querySelector(".".concat(selectorItem)) ||
                this.mySelf.querySelector(".".concat(selectorOpt));
            var opened = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_MENU_ITEM_OPENED, {
                detail: { itemStatus: itemActive },
            });
            window.dispatchEvent(opened);
        }
    };
    BcMenuBehavior.prototype.changeMenuOverflow = function (value) {
        if (window.innerWidth >= menu_constants_7.BC_LG) {
            var menu = void 0;
            if (this.mySelf.classList.contains(menu_constants_4.BC_MENU)) {
                menu = this.mySelf;
            }
            else {
                menu = this.mySelf.querySelector('.bc-menu');
            }
            if (value === 'visible') {
                menu.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_SM_VISIBLE);
                menu.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_MD_HIDDEN);
            }
            else {
                menu.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_MD_HIDDEN);
                menu.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            }
        }
    };
    BcMenuBehavior.prototype.headerIsReady = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_HEADER_EXIST, function () {
            _this.quantityItemsEvent();
        });
    };
    BcMenuBehavior.prototype.setLogoutEvent = function (fn) {
        this.logoutFunction = fn;
    };
    BcMenuBehavior.prototype.getCurrentItemActive = function (element) {
        if (element.classList.contains(menu_constants_3.BC_MENU_ITEM_ACTIVE)) {
            this.currentItemActive = element;
            this.makeItemActive(this.currentItemActive);
        }
    };
    BcMenuBehavior.prototype.openItemClick = function (item, key, i) {
        var _this = this;
        var maxItem = 4;
        var _itemClickEvent = function (event) {
            var j = i;
            if (window.innerWidth >= menu_constants_7.BC_LG) {
                (0, helpers_1.replaceClass)(_this.headerMainContent, menu_constants_6.BC_MENU_HEADER_HIDDEN, menu_constants_4.BC_MENU_HEADER);
            }
            if (j < maxItem) {
                _this.makeSubmenuInactive();
            }
            var _openItem = _this.openItem(item, key);
            if (_this.selectedItem === undefined) {
                _this.selectedItem = item;
                _openItem(event);
            }
            else if (_this.selectedItem === item) {
                _this.selectedItem = undefined;
                _this.setState(exports.ACTIVE_STATE);
                _this.makeItemInactive(item);
            }
            else {
                _this.selectedItem = item;
                _openItem(event);
            }
        };
        return _itemClickEvent;
    };
    BcMenuBehavior.prototype.openItem = function (item, key) {
        var _this = this;
        var _openItem = function (event) {
            if (item.getAttribute(common_constants_1.BcCommonConstants.ATTR_HREF) === '#' ||
                item.getAttribute(common_constants_1.BcCommonConstants.ATTR_HREF) === '') {
                event.preventDefault();
            }
            var body = _this.bodies.get(key);
            _this.makeItemsInactive();
            _this.makeBodiesInactive();
            _this.makeBodyActive(body);
            (0, helpers_1.replaceClass)(_this.drawer, menu_constants_2.BC_MENU_DRAWER, menu_constants_1.BC_MENU_DRAWER_ACTIVE);
            _this.headerMainContent = _this.mySelf.querySelector("div[class^='".concat(menu_constants_4.BC_MENU_HEADER, "']"));
            _this.headerMainContent.querySelector('h5').innerText = item.querySelector('li div').innerHTML;
            if (item.classList.contains(menu_constants_5.BC_MENU_ITEM_OPTIONS)) {
                _this.makeItemActive(item, menu_constants_6.BC_MENU_ITEM_OPTIONS_ACTIVE);
            }
            else {
                _this.makeItemActive(item);
            }
            _this.makeItemActive(item);
            if (_this.bodies.get(item.getAttribute('for'))) {
                _this.setState(exports.OPEN_STATE);
            }
            else {
                _this.setState(exports.ACTIVE_STATE);
                _this.selectedItem = undefined;
            }
        };
        return _openItem;
    };
    BcMenuBehavior.prototype.addItemEventClick = function (item, width, identifier) {
        var _this = this;
        item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (width < menu_constants_7.BC_LG) {
                if (_this.stateOptionSubmenu === exports.COLLAPSED_STATE) {
                    (0, helpers_1.replaceClass)(_this.headerMainContent, menu_constants_4.BC_MENU_HEADER, menu_constants_6.BC_MENU_HEADER_HIDDEN);
                    _this.stateOptionSubmenu = exports.OPEN_STATE;
                }
                else {
                    _this.stateOptionSubmenu = exports.COLLAPSED_STATE;
                    _this.makeBodyInactive(_this.bodies.get(identifier));
                }
            }
            else {
                (0, helpers_1.replaceClass)(_this.headerMainContent, menu_constants_4.BC_MENU_HEADER, menu_constants_6.BC_MENU_HEADER_HIDDEN);
            }
        });
    };
    BcMenuBehavior.prototype.addChevronIcon = function (item, body) {
        var i = item.querySelectorAll('em');
        i[i.length - 1].innerText = 'arrow2-down';
        item.parentNode.insertBefore(body, item.nextSibling);
    };
    BcMenuBehavior.prototype.addEventCloseBtn = function () {
        this.makeItemsInactive();
        if (this.stateSubMenu === exports.COLLAPSED_STATE) {
            this.stateSubMenu = exports.ACTIVE_STATE;
            this.makeItemActive(this.itemElement, menu_constants_6.BC_MENU_ITEM_OPTIONS_ACTIVE);
            (0, helpers_1.replaceClass)(this.submenu, menu_constants_5.BC_MENU_SUBMENU, menu_constants_7.BC_MENU_SUBMENU_ACTIVE, true);
        }
        else {
            this.stateSubMenu = exports.COLLAPSED_STATE;
            (0, helpers_1.replaceClass)(this.submenu, menu_constants_7.BC_MENU_SUBMENU_ACTIVE, menu_constants_5.BC_MENU_SUBMENU, true);
            (0, helpers_1.replaceClass)(this.mainContent, menu_constants_2.BC_MENU_MAIN_CONTENT_ACTIVE, menu_constants_8.BC_MENU_MAIN_CONTENT);
            var itemOptions = this.mySelf.querySelector(".".concat(menu_constants_5.BC_MENU_ITEM_OPTIONS));
            (0, helpers_1.replaceClass)(itemOptions, menu_constants_6.BC_MENU_ITEM_OPTIONS_ACTIVE, menu_constants_5.BC_MENU_ITEM_OPTIONS);
        }
        this.toggleItem();
    };
    BcMenuBehavior.prototype.addEventClickOnExtra = function (element) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.stateOptionSubmenu = exports.COLLAPSED_STATE;
            _this.stateSubMenu = exports.COLLAPSED_STATE;
            _this.makeSubmenuInactive();
            (0, helpers_1.replaceClass)(_this.headerMainContent, menu_constants_6.BC_MENU_HEADER_HIDDEN, menu_constants_4.BC_MENU_HEADER);
        });
    };
    BcMenuBehavior.prototype.onResizeMainContain = function (menu, main) {
        window.onresize = function (event) {
            if (window.innerWidth > menu_constants_7.BC_SM && window.innerWidth < menu_constants_7.BC_LG) {
                main.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_MD);
                main.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_SM);
                main.classList.remove(menu_constants_1.BC_MENU_COLUMNS);
                menu.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_SM_VISIBLE);
                menu.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_MD_HIDDEN);
            }
            else if (window.innerWidth >= menu_constants_7.BC_LG) {
                main.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_MD);
                main.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_SM);
                main.classList.remove(menu_constants_1.BC_MENU_COLUMNS);
                menu.classList.add(menu_constants_1.BC_MENU_MAIN_CONTENT_MD_HIDDEN);
                menu.classList.remove(menu_constants_1.BC_MENU_MAIN_CONTENT_SM_VISIBLE);
            }
        };
    };
    BcMenuBehavior.prototype.closeMegaMenu = function () {
        var _this = this;
        var bindingThis = this;
        var element = Array.from(document.querySelectorAll('.bc-menu-content-column ul a'));
        for (var _i = 0, element_1 = element; _i < element_1.length; _i++) {
            var elements = element_1[_i];
            elements.addEventListener('click', function () {
                _this.setInitState();
            });
        }
    };
    return BcMenuBehavior;
}(menu_element_creator_1.BcMenuElementCreator));
exports.BcMenuBehavior = BcMenuBehavior;
